<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { IDEVIEWMODELS } from '@/utils/models'
import settingService from '@/services/ide/settings/setting.service'
import projectsService from '@/services/ide/projects.service'
import { useIdeStore } from '@/stores/ide.store'

import ideModal from '@/components/ide/ide/IdeModal.vue'

const ideStore = useIdeStore()
const route = useRoute()

const httpError = ref<string>('')
const httpErrorTimeOut = ref<NodeJS.Timeout | number | null>(null)
const httpSuccess = ref<string>('')
const httpSuccessTimeOut = ref<NodeJS.Timeout | number | null>(null)
const httpInProgress = ref<boolean>(false)

const isHttpInProgress = computed(() => {
  return httpInProgress.value
})
const isProject = computed(() => {
  return (ideStore.isProject?.name && ideStore.isProjectId) || false
})

/**
 * Save the project again
 */
const saveAgain = async () => {
  httpInProgress.value = true
  httpError.value = ''
  httpSuccess.value = ''
  await projectsService
    .autoSave()
    .then((response) => {
      if (response) {
        httpSuccess.value = 'Project updated and saved successfully'
      }
    })
    .catch((err) => {
      httpError.value = err.message
    })
    .finally(() => {
      httpInProgress.value = false
    })
}

onMounted(() => {
  watch(route, () => {
    httpError.value = ''
    httpSuccess.value = ''
  })
  watch(httpError, () => {
    if (httpError.value) {
      if (httpErrorTimeOut.value) clearTimeout(httpErrorTimeOut.value)
      httpErrorTimeOut.value = setTimeout(() => {
        httpError.value = ''
      }, 3000)
    }
  })
  watch(httpSuccess, () => {
    if (httpSuccess.value) {
      if (httpSuccessTimeOut.value) clearTimeout(httpSuccessTimeOut.value)
      httpSuccessTimeOut.value = setTimeout(() => {
        httpSuccess.value = ''
        settingService.closePopup(IDEVIEWMODELS.SAVE)
      }, 3000)
    }
  })
})

watch(
  () => ideStore.isSettingPopupHs,
  () => {
    if (ideStore.isSettingPopupHs === IDEVIEWMODELS.SAVE) {
      if (isProject.value) {
        saveAgain()
      }
    }
  }
)
</script>

<template>
  <ideModal title="Save your project" class="sm:mt-[8vh]">
    <div class="flex h-full flex-col gap-2">
      <div class="flex h-32 items-center justify-center gap-2" :class="{ hidden: !httpSuccess }">
        <FontAwesomeIcon icon="fa-check" class="success h-5 w-5" />
        <p class="text-midnightBlue mb-0.5 text-center text-xs">
          {{ httpSuccess }}
        </p>
      </div>
      <div class="flex h-32 items-center justify-center" :class="{ hidden: !isHttpInProgress }">
        <p class="text-midnightBlue text-center text-xs">Saving your project, Please wait...</p>
      </div>
    </div>
  </ideModal>
</template>
